import { buildDeliveryNoteUnitOptions } from "./deliveryNoteUnits";

// Requisitions and orders keep quantities and prices in the main purchase unit.
// The display level only changes how those values are entered and presented.
export function requisitionUnitOptions(line = {}, item, units = [], languageId) {
  return buildDeliveryNoteUnitOptions({ ...line, ...(item || line.item) }, units, languageId);
}

export function selectedRequisitionUnit(line, item, units, languageId) {
  const options = requisitionUnitOptions(line, item, units, languageId);
  return options.find((option) => option.level === (line?.display_unit_level || "unit")) || options[0] || null;
}

export function requisitionDisplayQuantity(line, option) {
  if (line.quantity === "" || line.quantity == null) return "";
  return Number((Number(line.quantity) * (option?.factor || 1)).toFixed(8));
}

export function requisitionCanonicalQuantity(value, option) {
  if (value === "") return "";
  if (!option || option.factor === 1) return value;
  const quantity = Number(value) / (option?.factor || 1);
  return Math.abs(quantity - Math.round(quantity)) < 1e-9 ? Math.round(quantity) : quantity;
}

export function requisitionQuantityError(line, item, units, languageId, t) {
  if (!line?.item_id) return "";
  const options = requisitionUnitOptions(line, item, units, languageId);
  if (line.display_unit_level && line.display_unit_level !== "unit" && !options.some((option) => option.level === line.display_unit_level)) {
    return t("The selected presentation is no longer available for this item.");
  }
  if (line.quantity === "" || line.quantity == null) return "";
  const quantity = Number(line.quantity);
  if (!Number.isFinite(quantity) || quantity <= 0) return t("Enter a quantity greater than zero.");
  if (options.length < 2 || Math.abs(quantity - Math.round(quantity)) < 1e-9) return "";
  const main = options[0];
  const selected = selectedRequisitionUnit(line, item, units, languageId);
  const multiple = selected.level === "unit" ? options[1] : selected;
  return t("This item is purchased in {pack} of {count} {unit}; please choose a multiple.", {
    pack: main.label,
    count: multiple.factor.toLocaleString(languageId === "es" ? "es-ES" : "en-GB", { maximumFractionDigits: 8 }),
    unit: multiple.label,
  });
}

export function requisitionDisplayPrice(price, option, locale) {
  return (Number(price || 0) / (option?.factor || 1)).toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: option?.factor && option.factor !== 1 ? 8 : 2,
  });
}
